/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Integrations_Api_KeyInputs */



/**
* | output |
* | --- |
* | "API Key" |
*
* @param {Options_Integrations_Api_KeyInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_integrations_api_key = /** @type {((inputs?: Options_Integrations_Api_KeyInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Integrations_Api_KeyInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Clé API")
	if (locale === "de") return /** @type {LocalizedString} */ ("API-Schlüssel")
	if (locale === "it") return /** @type {LocalizedString} */ ("Chiave API")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Ключ API")
	if (locale === "es") return /** @type {LocalizedString} */ ("Clave API")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("API密钥")
	if (locale === "ja") return /** @type {LocalizedString} */ ("APIキー")
	if (locale === "hi") return /** @type {LocalizedString} */ ("एपीआई कुंजी")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Chave de API")
	return /** @type {LocalizedString} */ ("API Key")
});